import projetosRotas from './projetos/ProjetosRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'
import apoiosRotas from './apoios/ApoiosRotas'
import etapasRotas from './etapas/EtapasRotas'

export default {
    path: 'gerentes',
    name: 'Sgtec_Gerentes',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        projetosRotas,
        ...etapasRotas,
        pagamentosRotas,
        apoiosRotas
    ]
}
